import React, { Fragment, useContext, useRef, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { API, handleError, postRequestConfig } from './api';
import FormTextInput from './FormTextInput';
import { validateEmail } from './Register';
import UserSettingsContext from './UserSettingsContext';

function ResetPassword() {
  const { t } = useTranslation("translations");

  const history = useHistory();
  const location = useLocation();
  const { userSettings = {} } = useContext(UserSettingsContext);

  const [emailValid, setEmailValid] = useState(undefined);
  const [processing, setProcessing] = useState(false);
  const [error, setError] = useState(undefined);

  const emailRef = useRef(true);
  const active = useRef(true);

  const { state = {} } = location;
  const { redirectTo } = userSettings;
  const { protocol, host } = document.location;
  const redirect = (state.redirect)
  || redirectTo
  || `${protocol}//${host}/connect/`;

  function getEmailValidation(value) {
    const valid = validateEmail(value);
    setEmailValid(valid);
    return valid ? undefined : t('Please check the spelling of your email address.');
  }

  function processForm(event) {
    const email = emailRef.current.value;
    event.preventDefault();
    if (processing) {
      return;
    }
    setProcessing(true);
    fetch(`${API}/reset/password`, {
      ...postRequestConfig,
      body: `email=${
        encodeURIComponent(email)
      }&redirect=${
        encodeURIComponent(redirect)
      }`,
    })
    .then(handleError)
    .then(() => {
      if (!active.current) {
        // We have been unmounted already
        return;
      }
      setProcessing(false);
      history.push({
        pathname: '/verify',
        state: {
          ...state,
          email,
          verify: 'password',
        }
      });
   })
    .catch((error) => {
      if (!active.current) {
        // We have been unmounted already
        return;
      }
      console.error(error);
      setError(t('Password resetting failed. Please try again.'));
      setProcessing(false);
    });
  }

  return (
    <Fragment>
      <header>
        <h1>{t('Link for password resetting!')}</h1>
      </header>
      <main>
        <p>
          {t('Send a password resetting link to your email.')}
        </p>
        <form onSubmit={processForm}>
        <FormTextInput
            ref={emailRef}
            label={t('Email address')}
            id="email"
            type="email"
            name="email"
            defaultValue={state.email || ''}
            autoFocus
            required
            title={t('The email address you used to register for the service.')}
            placeholder=""
            getValidationError={getEmailValidation}
          />
          <input
            type="submit"
            disabled={processing || !emailValid}
            value={t('OK')}
          />
        </form>
        {error
          ? <p className="error">{error}</p>
          : undefined
        }
      </main>
    </Fragment>
  );
}

export default ResetPassword;
